import { useContext } from 'react';
import { UploadContext } from './provider';
export const useUploadRotationTimeSlots = () => useContext(UploadContext);
